require('social-share.js/dist/js/jquery.share.min.js');

function share () {
  if ($('.post-share').length) {
    $('.post-share').share({
      disabled: ['tencent', 'douban', 'linkedin', 'diandian', 'facebook', 'google'],
      wechatQrcodeTitle: "微信扫一扫",
      wechatQrcodeHelper: '<p>微信扫一扫，右上角分享</p>',
      source: CONFIG.site.title
    });
  };

  if (window.webviewSDK) {
    var cfg = {
        title: document.title
    };
    if (document.querySelector(".post-body")) {
      cfg.desc = document.querySelector(".post-body").innerText.substring(0, 100).replace(/\n/g, ' ') + '…'
    };
    if (document.querySelector(".post-body img")) {
        cfg.imgUrl = document.querySelector(".post-body img").src
    };
    webviewSDK.updateShareInfo(cfg)
  }
}

module.exports = share;
